/**
 * The path part of a route: no query string, no fragment, no trailing slash (except the root).
 * Navigation tracking compares destinations as paths so `/score?x=1` and `/score#top` are the
 * same screen, matching how the nav components derive `activeRoute`.
 */
export function routePath(url: string | null | undefined): string {
  if (!url) {
    return "";
  }
  const path = url.split("?")[0].split("#")[0];
  return path.length > 1 && path.endsWith("/") ? path.slice(0, -1) : path;
}
